// Detecção de dispositivo coerente entre SSR e cliente, para evitar o "flash"
// de layout (o desktop aparecer por um instante antes do mobile).
//
// Problema do isMobile() global (shared/utils/mobile.ts): no SSR ele sempre
// retorna false (não há `screen`/`window`), então o servidor manda o HTML do
// DESKTOP e o cliente só troca para o mobile depois de hidratar — é esse HTML
// de desktop, pintado antes da hidratação, que causa o flash.
//
// Aqui usamos o User-Agent (única pista de dispositivo disponível no servidor)
// para o render inicial — idêntico no SSR e na PRIMEIRA render do cliente, então
// não há hydration mismatch e o HTML já vem no layout certo para celulares.
// Depois de montar, reconciliamos com a MESMA regra de largura do isMobile()
// global (screen.width < 770), cobrindo aparelhos em que o UA e a largura
// divergem (ex.: tablets). Para a maioria dos celulares UA e largura coincidem,
// então não há re-render pós-montagem (sem flash).
const MOBILE_UA =
  /Android.*Mobile|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone/i;

// `maxMobileWidth`: maior largura (px) ainda tratada como mobile, comparada com
// `screen.width` (default 769 ≡ a regra global `< 770`). A tela de planos passa
// 970 para manter o carrossel de 1 card até iPads/tablets, onde o grid de 3
// cards fica espremido.
export function useIsMobileDevice(maxMobileWidth = 769) {
  const userAgent = import.meta.server
    ? useRequestHeaders(["user-agent"])["user-agent"] ?? ""
    : navigator.userAgent;

  const isMobile = ref(MOBILE_UA.test(userAgent));

  onMounted(() => {
    // Alinha com a regra usada no resto do app (shared/utils/mobile.ts).
    isMobile.value = screen.width <= maxMobileWidth;
  });

  return isMobile;
}
